import { motion, usePresenceData } from "motion/react";
import { PropsWithChildren } from "react";

type Direction = "left" | "right" | "up" | "down";

const getClipPath = (
  direction: Direction,
  isReversedDirection?: boolean,
): string => {
  switch (direction) {
    case "left":
      return isReversedDirection
        ? "inset(0% 0% 0% 100%)"
        : "inset(0% 100% 0% 0%)";
    case "right":
      return isReversedDirection
        ? "inset(0% 100% 0% 0%)"
        : "inset(0% 0% 0% 100%)";
    case "up":
      return isReversedDirection
        ? "inset(0% 0% 100% 0%)"
        : "inset(100% 0% 0% 0%)";
    case "down":
      return isReversedDirection
        ? "inset(100% 0% 0% 0%)"
        : "inset(0% 0% 100% 0%)";
  }
};

export const SimpleRevealingAnimation = ({
  children,
  duration = 0.6,
}: PropsWithChildren<{ duration?: number }>) => {
  const { animationDirection } = usePresenceData() as {
    animationDirection: Direction;
  };

  return (
    <motion.div
      initial={{
        clipPath: getClipPath(animationDirection),
      }}
      exit={{ clipPath: getClipPath(animationDirection, true) }}
      animate={{
        clipPath: `inset(0% 0% 0% 0%)`,
        transition: { duration: duration, ease: "easeInOut" },
      }}
    >
      {children}
    </motion.div>
  );
};
